import { ENV } from '@/shared/config'

/** Скрипт и префикс кэша — те же, что в `service-worker/sw.js`. */
const SW_URL = '/sw.js'
const CACHE_PREFIX = 'tapgift-shell-'

/** Снять Service Worker и стереть его кэш: dev-сервер или аварийный выключатель. */
const removeServiceWorker = async (): Promise<void> => {
  try {
    const registrations = await navigator.serviceWorker.getRegistrations()

    await Promise.all(registrations.map((registration) => registration.unregister()))

    if ('caches' in window) {
      const keys = await caches.keys()

      await Promise.all(keys.filter((key) => key.startsWith(CACHE_PREFIX)).map((key) => caches.delete(key)))
    }
  } catch {
    // Хранилище недоступно — снимать нечего.
  }
}

const register = (): void => {
  navigator.serviceWorker
    .register(SW_URL, { scope: '/', updateViaCache: 'none' })
    .catch((error: unknown) => console.warn('[sw] не зарегистрирован — приложение работает без офлайн-оболочки', error))
}

/**
 * Service Worker — оболочка приложения (`index.html` и ассеты) без сети
 * (итерация 7). Стратегии — в `service-worker/sw.js`, список файлов и версию
 * подставляет сборка (`service-worker/vite-plugin.ts`).
 *
 * - **Не обязателен.** Нет `navigator.serviceWorker` (WebView Telegram на iOS,
 *   http не на localhost) или регистрация не удалась — приложение работает
 *   как без него: всё из сети, ваучер — из `localStorage`.
 * - **Только в сборке.** В dev-сервере его нет, а оставшийся от `pnpm preview`
 *   на том же адресе снимается — иначе он отвечал бы за dev-сервер.
 * - **После `load`**: предзагрузка оболочки не делит сеть с первым экраном.
 * - `VITE_SERVICE_WORKER=false` — аварийный выключатель: регистрация
 *   снимается, кэш стирается (сам `sw.js` в такой сборке тоже самоудаляется).
 */
export const setupServiceWorker = (): void => {
  try {
    if (!('serviceWorker' in navigator)) {
      return
    }

    if (ENV.IS_DEV || !ENV.SERVICE_WORKER) {
      void removeServiceWorker()

      return
    }

    if (document.readyState === 'complete') {
      register()
    } else {
      window.addEventListener('load', register, { once: true })
    }
  } catch {
    // Некоторые WebView бросают на само обращение к `navigator.serviceWorker` — живём без него.
  }
}
